import { render, staticRenderFns } from "./CreditorsComponent.vue?vue&type=template&id=32c296d5&scoped=true"
import script from "./CreditorsComponent.vue?vue&type=script&lang=js"
export * from "./CreditorsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c296d5",
  null
  
)

export default component.exports